import { useBunja } from 'bunja/react';
import Image from 'next/image';

import { useRouter } from '@flipster/i18n/routing';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';

import { entryPopupBlockBunja, entryPopupItemBunja } from '../../bunja';
import AffiliateDashboardImg from './img_affiliate_dashboard.webp';

export const AffiliateDashboardRenewalModal = () => {
  const router = useRouter();
  const { popup, onClose } = useBunja(entryPopupItemBunja);
  const { block } = useBunja(entryPopupBlockBunja);

  if (popup.id !== 'NEW_AFFILIATE_DASHBOARD') throw new Error('Popup ID mismatch');

  return (
    <Modal css={{ width: 'auto' }}>
      <Modal.Close
        onClose={() => {
          onClose();
        }}
      />
      <Modal.Header>
        <Modal.Title label='Your Affiliate Dashboard has been upgraded' />
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
          View detailed reward data by period and referee, gain insights, and grow your earnings with confidence.
        </p>
      </Modal.Header>
      <Modal.Content>
        <Image
          src={AffiliateDashboardImg}
          alt='affiliate dashboard'
          width={736}
          height={538}
          className={css({ maxW: '100%', height: 'auto' })}
          priority
        />
      </Modal.Content>
      <Modal.Footer css={{ pb: 32, pt: 0 }}>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          label='Explore new dashboard'
          onClick={() => {
            router.push(`/support/affiliate`);
            block('NEW_AFFILIATE_DASHBOARD');
            onClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
